/* Copyright (c) 2017 Backpack Health LLC */

class ApiErrorModel {
  constructor(apiResponse = {}) {
    this.response = apiResponse;
    this.data = apiResponse.data || {};
  }

  messageKey() {
    return this.data.key;
  }

  status() {
    return this.response.status;
  }

  responseMessage() {
    return this.response.status ? `${this.response.status}: ${this.response.message}` : this.response.message;
  }

}

export default ApiErrorModel;
